import { Box } from '@/styled-system/jsx'

export const Div = Box
